module.exports = __webpack_public_path__ + "img/triangle-person-digging.6d4f9df0.svg";